import { VNodeChildren, h } from 'vue';
//@ts-ignore
import { BNavbarDropdown } from 'buefy/dist/esm/navbar';

const templateTagName = 'template';
const dropdownLabelSlotName = 'label';
const dropdownContentSlotName = 'default';

export const navbarDropdown = (
  arrowless: boolean,
  right: boolean,
) => (
  trigger: VNodeChildren,
  items: VNodeChildren,
  classes: string | string[] | null = null,
) => h(
  BNavbarDropdown, {
    class: classes,
    props: {
      boxed: true,
      arrowless,
      right,
    },
  }, [
    h(templateTagName, { slot: dropdownLabelSlotName }, trigger),
    h(templateTagName, { slot: dropdownContentSlotName }, items),
  ],
);

export const dd = navbarDropdown(false, false);
export const ddr = navbarDropdown(true, true);
